/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */
import { Permission } from '../reducers/current-user';
import { InitiativePlain, RootConfig } from './initiative';
import { Scorecard } from './scorecard';
import { Alternative } from './universalTracker';

interface UTR {
  code: string;
  idString: string;
  name: string;
  type: string;
  valueType: string;
  _id: string;
}

interface ChildTargetInfo {
  sdgCode: string;
  inScope: boolean;
  actual?: number;
  utrId: string;
  utrCode: string;
  name: string;
  officialName: string;
  fragments: []
}

interface ChildGoalInfo {
  sdgCode: string;
  inScope: boolean;
  actual?: number;
  utrId: string;
  utrCode: string;
  utr: UTR,
  name: string;
  officialName: string;
  targets: ChildTargetInfo[],
}

export interface ScorecardChild {
  goals: ChildGoalInfo[];
  actual?: number;
  initiativeId: string;
  initiativeName: string;
  initiativeTags: string[];
  initiativeProfile?: string;
  initiativeType: string;
  initiativePermissionGroup: string;
  utr: UTR;
  weight: number;
}

export interface PortfolioScorecard {
  scorecard: Scorecard;
  weight: number;
  children: ScorecardChild[];
}

export interface Portfolio extends InitiativePlain {
  scorecard: PortfolioScorecard;
  userPermissions: Permission;
  config?: RootConfig;
}

interface ScopePackStats {
  created: number;
  updated: number;
  rejected: number;
  verified: number;
  na: number;
  nr: number;
  isPrivate: number;
  totalUtrvs: number;
}

interface SurveyCounter {
  surveyCount: number;
  initiativeUniqueCount: number;
}

export interface ScopePackRowData extends ScopePackStats, SurveyCounter {
  code: string;
  name: string;
}

export interface PackUsageApiResponse {
  packs: ScopePackRowData[];
}

export interface SubmissionInsightsUtr {
  _id: string;
  alternatives: { [key: string]: Alternative },
  type: string;
  typeCode: string;
  unit: string;
  name: string;
}

export interface SubmissionInsightsUtrv {
  universalTrackerId: string;
  average: number;
  count: number;
  total: number;
}
export interface SubmissionInsightsRowValues {
  initiativeId?: string;
  name: string;
  industryText?: string;
  superSectorText?: string;
  sectorText?: string;
  subSectorText?: string;
  utrvs: SubmissionInsightsUtrv[];
}

export enum ClassificationsLabels {
  industryText =  'Industry',
  superSectorText = 'Super sector',
  sectorText = 'Sector',
  subSectorText = 'Sub sector',
}

export interface SubmissionInsightsData {
  utrs: SubmissionInsightsUtr[],
  utrValues: SubmissionInsightsRowValues[];
}
